import { render, staticRenderFns } from "./sample-invoice.vue?vue&type=template&id=28abd12d&scoped=true"
import script from "./sample-invoice.vue?vue&type=script&lang=js"
export * from "./sample-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28abd12d",
  null
  
)

export default component.exports